import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import ScienceTwoToneIcon from "@mui/icons-material/ScienceTwoTone";
import BiotechTwoToneIcon from "@mui/icons-material/BiotechTwoTone";

import SanitizerTwoToneIcon from "@mui/icons-material/SanitizerTwoTone";
import { Link } from "react-router-dom";

const Benefit = () => {
	const classes = useStyles();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<Box
			className={classes.benefit}
			sx={{
				display: "flex",
				alignItems: "center",
				flexDirection: "column",
				py: 8,
			}}
		>
			<Typography className={classes.benefit_text}>
				The Benefits of Our Patented Technology
			</Typography>

			<Grid
				sx={{
					width: "80%",
					mx: "auto",
				}}
				className={classes.benefit__contents}
				container
			>
				<Grid item md={4} className={classes.benefit__grids}>
					<Box
						className={classes.hoverOverEffect}
						m={2}
						p={3}
						sx={{
							border: "1px solid #fafafa",
							borderRadius: "8px",
							boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
						}}
					>
						<ScienceTwoToneIcon className={classes.benefit__icons} />
						<div className={classes.benefit_title}>
							<Link to="/tech#hybrid">HybridMax</Link>
						</div>
						<div className={classes.benefit__exp}>
							Eliminate harmful germs that damage your skin cells. Sonovia's
							patented formula is proven to eliminate over 99.9% of harmful
							viruses and bacteria.
							<Box sx={{ pt: 2 }}>
								<Button variant="outlined">Learn More</Button>
							</Box>
						</div>
					</Box>
				</Grid>
				<Grid item md={4} className={classes.benefit__grids}>
					<Box
						className={classes.hoverOverEffect}
						m={2}
						p={3}
						sx={{
							border: "1px solid #fafafa",
							borderRadius: "8px",
							boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
						}}
					>
						<BiotechTwoToneIcon className={classes.benefit__icons} />
						<div className={classes.benefit_title}>Ultra Phenix</div>
						<div className={classes.benefit__exp}>
							Eliminate harmful germs that damage your skin cells. Sonovia's
							patented formula is proven to eliminate over 99.9% of harmful
							viruses and bacteria.
							<Box sx={{ pt: 2 }}>
								<Button variant="outlined">Learn More</Button>
							</Box>
						</div>
					</Box>
				</Grid>
				<Grid item md={4} className={classes.benefit__grids}>
					<Box
						className={classes.hoverOverEffect}
						m={2}
						p={3}
						sx={{
							border: "1px solid #fafafa",
							borderRadius: "8px",
							boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
						}}
					>
						<SanitizerTwoToneIcon className={classes.benefit__icons} />
						<div className={classes.benefit_title}>Magic Clean</div>
						<div className={classes.benefit__exp}>
							Eliminate harmful germs that damage your skin cells. Sonovia's
							patented formula is proven to eliminate over 99.9% of harmful
							viruses and bacteria.
							<Box sx={{ pt: 2 }}>
								<Button variant="outlined">Learn More</Button>
							</Box>
						</div>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Benefit;

const useStyles = makeStyles({
	benefit: { minHeight: "300px", width: "100%" },
	benefit_text: { textAlign: "center", paddingTop: "50px", fontSize: "42px" },
	benefit__contents: {
		paddingTop: "30px",
		marginLeft: "20px",
		marginRight: "20px",
		display: "flex",
	},
	benefit__icons: {
		fontSize: "52px",
		border: "1px solid black",
		borderRadius: "50%",
		padding: "10px",
	},
	benefit__exp: { fontSize: "15px", paddingTop: "10px" },
	benefit__grids: {
		textAlign: "center",
		lineHeight: "1.3em",
		paddingBottom: "70px",
		paddingTop: "20px",
	},

	benefit_title: { fontWeight: "bold", paddingTop: "20px" },
	hoverOverEffect: {
		cursor: "pointer",
		backgroundColor: "white",
		transition: "all .2s ease-in-out",
		"&:hover": {
			transform: "scale(1.0001)",
			boxShadow: "rgba(0, 0, 0, 0.34) 0px 6px 17px",
		},
	},
});
